class Text {

    init( textElements ) {
        this.textElements = textElements;
        this.readmores = document.querySelectorAll('[data-readmore]');


        this.readmores.forEach((readmore) => {
            readmore.addEventListener( 'click', ( event ) => { 
                this.toggleExtra(readmore); 
            } )

        })
    }

    toggleExtra(readmore) {

        var id =  readmore.dataset.readmore;
        var extra = document.querySelector('[data-extra="' + id + '"]');
        var top =  document.querySelector('[data-text="' + id + '"]');

        if (readmore.classList.contains('visible')) {
            setTimeout(function() {
                top.scrollIntoView({ behavior: "smooth"});
            }, 1000);
        }

        extra.classList.toggle('visible');
        readmore.classList.toggle('visible');

       
    }
    
}

export const text = new Text();